import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Zap } from "lucide-react";
export default function ReadyToMove() {
  return <section data-section-id="230129" id="ready-to-move" className="dark bg-secondary text-foreground py-16 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="bg-secondary text-foreground rounded-lg p-8 sm:p-12 lg:p-16 shadow-3xl relative overflow-hidden border border-white/10">
          {}
          <div className="absolute top-0 right-0 -mt-16 -mr-16 w-64 h-64 bg-primary/20 rounded-lg blur-3xl pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 -mb-16 -ml-16 w-48 h-48 bg-primary/10 rounded-lg blur-2xl pointer-events-none"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8 relative z-10">
            {}
            <div className="flex flex-col items-start justify-center space-y-6">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-serif leading-tight tracking-tight uppercase">
                Ready to Shift?
              </h2>
              <p className="text-lg md:text-xl text-foreground/90 font-default max-w-md">
                Experience a stress-free residential move with our expert packing and careful handling services.
              </p>
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 border-none rounded-md font-semibold px-8 mt-4 shadow-lg transition-all duration-300">
                <Link to="/GetQuotePage">
                  Get a Quote <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>

            {}
            <div className="flex flex-col items-start justify-center space-y-6 md:border-l md:border-foreground/20 md:pl-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-serif leading-tight tracking-tight uppercase">
                Business Logistics
              </h2>
              <p className="text-lg md:text-xl text-foreground/90 font-default max-w-md">
                Scale your operations with our professional commercial relocation and personalized logistics planning.
              </p>
              <Button asChild size="lg" className="bg-foreground text-secondary hover:bg-foreground/90 border-none rounded-md font-semibold px-8 mt-4 shadow-xl transition-all duration-300">
                <Link to="/ResourcesPage">
                  View Resources <Zap className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}